<template>
  <div class="print-container">

    <!-- ===== HEADER ===== -->
    <div class="header">
      <h2>تقرير المبيعات</h2>
      <div class="meta">
        <span>من: {{ filters.from }}</span>
        <span>إلى: {{ filters.to }}</span>
      </div>
    </div>

    <!-- ===== MOST SOLD PRODUCTS ===== -->
    <h3 class="section-title">مبيعات الأصناف
      <span>{{ filters.kitchenType }}</span>
      <!-- <span v-if="filters.type"> - {{ filters.type }}</span> -->
    </h3>
    <table>
      <thead>
        <tr>
          <th>#</th>
          <th>المنتج</th>
          <th>المقاس</th>
          <th>الكمية</th>
          <th>الإجمالي</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(row, i) in mostSoldProducts" :key="i">
          <td>{{ i + 1 }}</td>
          <td>{{ row.name }}</td>
          <td>{{ row.size }}</td>
          <td>{{ row.totalQty }}</td>
          <td>{{ format(row.totalCost) }}</td>
        </tr>
      </tbody>

      <tfoot>
        <tr>
          <td colspan="3">إجمالي الأصناف</td>
          <td>{{ totalQtyProducts }}</td>
          <td>{{ format(totalAmountProducts) }}</td>
        </tr>
      </tfoot>
    </table>

    <!-- ===== MOST SOLD SECOND PRODUCTS ===== -->
    <h3 class="section-title">مبيعات الإضافات

       <span v-if="filters.type"> - {{ filters.type.name }}</span>
    </h3>
    <table>
      <thead>
        <tr>
          <th>#</th>
          <th>الإضافة</th>
          <th>المقاس</th>

          <th>الكمية</th>
          <th>الإجمالي</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(row, i) in mostSoldSecondProducts" :key="i">
          <td>{{ i + 1 }}</td>
          <td>{{ row.name }}</td>
           <td>{{ row.size }}</td>
          <td>{{ row.totalQty }}</td>
          <td>{{ format(row.totalCost) }}</td>
        </tr>
      </tbody>

      <tfoot>
        <tr>
          <td colspan="3">إجمالي الإضافات</td>
          <td>{{ totalQtyAddons }}</td>
          <td>{{ format(totalAmountAddons) }}</td>
        </tr>
      </tfoot>
    </table>

    <!-- ===== GRAND TOTAL ===== -->
    <table class="grand-total">
       <tfoot>
      <tr>
        <td>الإجمالي الكلي</td>
        <td>{{ format(grandTotal) }}</td>
      </tr>
      </tfoot>
    </table>

  </div>
</template>

<script>
export default {
  name: 'ProductSalesPrintLayout',
  props: {
    mostSoldProducts: Array,
    mostSoldSecondProducts: Array,
    filters: Object
  },
  computed: {
    totalQtyProducts() {
      return this.mostSoldProducts.reduce((s, i) => s + i.totalQty, 0)
    },
    totalAmountProducts() {
      return this.mostSoldProducts.reduce((s, i) => s + i.totalCost, 0)
    },
    totalQtyAddons() {
      return this.mostSoldSecondProducts.reduce((s, i) => s + i.totalQty, 0)
    },
    totalAmountAddons() {
      return this.mostSoldSecondProducts.reduce((s, i) => s + i.totalCost, 0)
    },
     grandTotal() {
      return this.totalAmountProducts + this.totalAmountAddons
    }
  },
  methods: {
    format(v) {
      return new Intl.NumberFormat('en-EG', {
        style: 'currency',
        currency: 'EGP'
      }).format(v)
    }
  }
}
</script>

